<template>
  <div :class="$style.success">
    <Title>感謝您的愛心</Title>

    <hr>

    <FormRow
      v-for="(field, i) in fields"
      :key="i"
    >
      <template #left>
        <FormLabel
          small
          :for="field.name"
        >
          {{ field.label }}
        </FormLabel>
      </template>
      <template #right>
        <div
          :class="$style.desc"
          v-html="getDesc(field.name)"
        />
      </template>
    </FormRow>

    <hr>

    <FormRow>
      <template #left>
        <FormLabel small>
          請問您如何得知 TFT 相關訊息？
        </FormLabel>
      </template>
      <template #right>
        <SelectInput
          id="related-info"
          placeholder="請選擇"
          :value.sync="form.relatedInfo"
          :options="[
            'Teach For Taiwan 官網',
          ]"
        />
      </template>
    </FormRow>

    <FormRow>
      <template #right>
        <TextInput
          id="related-info"
          placeholder="您可以填寫從何獲得 TFT 的資訊"
          :value.sync="form.relatedInfoCustom"
        />
      </template>
    </FormRow>

    <FormRow>
      <CheckBoxRadioInput
        :value.sync="form.newsletter"
        label="同意定期收到 TFT 電子報（略過步驟視為不同意）"
      />
    </FormRow>

    <FormRow>
      <Button>確認送出</Button>
    </FormRow>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Title from '@/components/Title.vue';
import FormRow from '@/components/form/FormRow.vue';
import FormLabel from '@/components/form/FormLabel.vue';
import Button from '@/components/buttons/Button.vue';
import SelectInput from '@/components/inputs/SelectInput.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import CheckBoxRadioInput from '@/components/inputs/CheckBoxRadioInput.vue';

export default {
  components: {
    Title,
    FormRow,
    FormLabel,
    Button,
    SelectInput,
    TextInput,
    CheckBoxRadioInput,
  },
  data() {
    return {
      form: {
        newsletter: false,
        relatedInfo: null,
        relatedInfoCustom: null,
      },
      fields: [
        {
          name: 'amount',
          label: '捐款金額',
        },
        {
          name: 'paymentType',
          label: '付款方式',
        },
        {
          name: 'info',
          label: '訂單資訊',
        },
      ],
    };
  },
  computed: {
    formatAmount() {
      return this.amount
        ? `$${ this.amount }`
        : '';
    },
    ...mapState({
      amount: state => state.success.amount, // 捐款金額
      paymentType: state => state.success.paymentType, // 付款方式
      info: state => state.success.info, // 訂單資訊
      bankCode: state => state.success.bankCode, // 銀行代碼
      bankAccount: state => state.success.bankAccount, // 付款帳號
      deadline: state => state.success.deadline, // 繳費期限
    }),
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getDesc(name) {
      switch (name) {
        case 'info':
          return this.getInfo();
        case 'amount':
          return this.formatAmount;
        default:
          return this[name] || '';
      }
    },
    getInfo() {
      if(_.includes([
        this.formatAmount,
        this.bankCode,
        this.backAccount,
        this.info,
      ], null)) return '';

      return `
        <span>您的 ATM 捐款帳號如下：</span><br>
        <br>
        <span>請透過 ATM 轉帳至以下銀行帳號以完成繳費<span><br>
        <span style="display: inline-block;padding-right: 1rem;">付款金額</span><span>${ this.formatAmount }</span><br>
        <span style="display: inline-block;padding-right: 1rem;">付款帳號</span><span>${ this.bankCode }</span><br>
        <span style="display: inline-block;width: 5rem;"></span>${ this.bankAccount }<br>
        <span style="display: inline-block;padding-right: 1rem;">繳費期限</span><span>${ this.deadline }</span><br>
        <br>
        ${ this.info }
      `;
    },
    ...mapActions({
      fetch: 'success/fetch',
    }),
  },
};
</script>

<style lang="scss" module>
.success {
  padding: 1rem;
}

.desc {
  text-align: left;
}
</style>
